import { render, staticRenderFns } from "./riskProcessPop.vue?vue&type=template&id=3692b56c"
import script from "./riskProcessPop.vue?vue&type=script&lang=js"
export * from "./riskProcessPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3692b56c')) {
      api.createRecord('3692b56c', component.options)
    } else {
      api.reload('3692b56c', component.options)
    }
    module.hot.accept("./riskProcessPop.vue?vue&type=template&id=3692b56c", function () {
      api.rerender('3692b56c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/riskProcessPop.vue"
export default component.exports